import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            关于丁香花影院的常见疑问，这里都有解答
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-7"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q{idx + 1}.</span>
                {item.question}
              </h3>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed pl-8">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}